import { AssetDeviceBreakdown } from "services/asset-management/AssetService";

// Asset types that mean the same thing for users are shown as one device type. Keys are the group names.
const DEVICE_TYPE_GROUPS: Record<string, string[]> = {
    laptop: ["laptop", "laptops", "notebook", "notebooks"],
    display: ["display", "monitor"],
    phone: ["phone", "mobile phone", "mobile device", "smartphone"],
};

export function toDeviceTypeGroup(assetType: string): string {
    const normalizedAssetType = assetType.trim().toLowerCase();
    const group = Object.keys(DEVICE_TYPE_GROUPS).find((name) =>
        DEVICE_TYPE_GROUPS[name].includes(normalizedAssetType)
    );
    return group ?? assetType;
}

export function groupDeviceBreakdowns(breakdowns: AssetDeviceBreakdown[]): AssetDeviceBreakdown[] {
    const groupedBreakdowns: Record<string, AssetDeviceBreakdown> = {};
    for (const breakdown of breakdowns) {
        const deviceType = toDeviceTypeGroup(breakdown.deviceType);
        const existing = groupedBreakdowns[deviceType];
        groupedBreakdowns[deviceType] = existing
            ? {
                  deviceType,
                  count: existing.count + breakdown.count,
                  hasDataBearing: existing.hasDataBearing || breakdown.hasDataBearing,
                  hasNonDataBearing: existing.hasNonDataBearing || breakdown.hasNonDataBearing,
              }
            : { ...breakdown, deviceType };
    }
    return Object.values(groupedBreakdowns);
}
